const IndustryTags = () => {
  document.querySelectorAll(".xo2026-industry-tags").forEach((section) => {
    const tags = [...section.querySelectorAll("[data-industry-tag]")];
    const images = [...section.querySelectorAll("[data-industry-image]")];

    const activate = (id) => {
      tags.forEach((tag) => {
        tag.classList.toggle("is-active", tag.dataset.industryTag === id);
      });

      images.forEach((image) => {
        const isActive = image.dataset.industryImage === id;
        image.hidden = !isActive;
      });
    };

    tags.forEach((tag) => {
      const showImage = () => activate(tag.dataset.industryTag);

      tag.addEventListener("pointerenter", showImage);
      tag.addEventListener("focus", showImage);
    });

    if (tags[0]) {
      activate(tags[0].dataset.industryTag);
    }
  });
};

export default IndustryTags;
